import React, {useContext} from "react";
import {Typography, Space, Button, Icon} from "@bezlimit/bezlimit-ui";
import {useTranslation} from "react-i18next";
import {isIOS, isMacOs} from "react-device-detect";
import {observer} from "mobx-react";
import _ from "lodash";
import "./style.scss";
// core
import {LayoutContext, ModalContext} from "../../../../../core/Contexts";
//component
import emptyImg from "../../../../../images/empty-result.png";

export default React.memo(
    observer(function ModalVerification() {
        const contextLayout = useContext(LayoutContext);
        const {t} = useTranslation();
        const contextModal = useContext(ModalContext);

        const onClose = () => {
            contextModal?.setVisible(false);
            contextModal?.setCssClass("");
        };
        const onClick = () => {
            if (isIOS || isMacOs) {
                window.open("https://apps.apple.com/ru/app/store-безлимит/id1495144217", "_blank");
            } else {
                window.open(
                    "https://play.google.com/store/apps/details?id=com.bezlimit.store&hl=ru",
                    "_blank"
                );
            }
            setTimeout(() => {
                onClose();
            }, 1000);
        };

        return (
            <Typography as="div" className="bl-verification-modal">
                <Button className="close-btn" onClick={onClose}>
                    <Icon name={"close"} size={"18px"} />
                </Button>
                <Space
                    size={_.gte(contextLayout?.width ?? 0, 768) ? 40 : 16}
                    direction="vertical"
                    align="center"
                >
                    <img
                        src={emptyImg}
                        alt=""
                        width={_.gte(contextLayout?.width ?? 0, 768) ? 116 : 88}
                    />
                    <Typography as="div">
                        <Space size={8} direction="vertical" align="center">
                            <Typography
                                size={_.gte(contextLayout?.width ?? 0, 768) ? 32 : 22}
                                level={2}
                            >
                                {t("Пройти верификацию \nвозможно через ")}
                                <br />
                                <span className="app-store" onClick={onClick}>
                                    мобильное приложение Store
                                </span>
                            </Typography>
                        </Space>
                    </Typography>
                </Space>
            </Typography>
        );
    })
);
